import { Button, ButtonGroup, Grid } from '@material-ui/core';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import ScheduleIcon from '@material-ui/icons/Schedule';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { useEffect } from 'react';
import { SplitButton } from './SnSplitButton';

import './App.css';
import { BlogList } from './BlogList';
import { initGA, trackPageView, trackExternalLink, trackDownload, trackContactAction } from './analytics';

const theme = createMuiTheme({
  typography: {
    button: {
      textTransform: 'none',
    },
  },
});

function App() {
  // Initialize GA4 when app loads
  useEffect(() => {
    initGA();
    trackPageView(window.location.pathname);
  }, []);

  // Enhanced button click handlers with tracking
  const handleButtonClick = (buttonName, url, isDownload = false) => {
    if (isDownload) {
      trackDownload(buttonName);
    } else {
      trackExternalLink(buttonName, url);
    }
    window.open(url, '_blank');
  };

  const handleContactClick = (action, url) => {
    trackContactAction(action);
    window.open(url, '_blank');
  };

  return (
    <ThemeProvider theme={theme}>
      <div>
        <div className="wrap">
          <section className="profile">
            <div className="portrait">
              <a href="/">
                <div className="spinner" />
                <div
                  className="img"
                  style={{
                    backgroundImage: 'url("/Shams_Nahid.jpg")',
                  }}
                />
              </a>
            </div>
            <h1 className="name">
              Shams <b>Nahid</b>
            </h1>
            <h2 className="title">Senior Software Engineer</h2>
            <h4 style={{ paddingBottom: '16px' }}>
              Node.js | React | Angular | React Native | MongoDB | AWS
            </h4>
            <Grid
              container
              justify="center"
              spacing={2}
              style={{ paddingBottom: 16 }}
            >
              <Grid item>
                <div style={{ display: 'flex' }}>
                  <PhoneIcon style={{ fontSize: 18, paddingRight: 4 }} />
                  +353 085 1879930
                </div>
              </Grid>
              <Grid item>
                <div style={{ display: 'flex' }}>
                  <LocationOnIcon style={{ fontSize: 18, paddingRight: 4 }} />
                  Limerick, Ireland
                </div>
              </Grid>
              <Grid item>
                <div style={{ display: 'flex' }}>
                  <EmailIcon style={{ fontSize: 18, paddingRight: 4 }} />
                  b.m.shamsnahid@gmail.com
                </div>
              </Grid>
              <Grid item>
                <a
                  style={{ display: 'flex', color: 'black', textDecoration: 'underline' }}
                  href='https://calendly.com/shams-nahid'
                  target='_blank'
                  rel="noreferrer"
                  onClick={() => handleContactClick('Schedule Call', 'https://calendly.com/shams-nahid')}
                >
                  <ScheduleIcon style={{ fontSize: 18, paddingRight: 4 }} />
                  Schedule A Call
                </a>
              </Grid>
            </Grid>
            <span className="bio">
              I am a disciplined Software Engineer with 7 years of experience. I am proficient in using JavaScript frameworks and working with AWS Cloud Infrastructure (2x AWS Associate Level Certifications). I have successfully collaborated with remote technical teams and clients from the USA, Singapore, Denmark and Japan. In addition to web technologies, I am also actively expanding my skills in Serverless and DevOps. My professional goal is to continue growing and working in the field of Engineering and Software Architecture.
            </span>
          </section>
        </div>
        <div style={{ padding: '22px' }}>
          <Grid container justify="center" spacing={1}>
            {/* <Grid item>
              <SplitButton
                options={[
                  {
                    title: "Download CV",
                    link: "https://docs.google.com/document/d/e/2PACX-1vS-Acr_Iv5FzfrL3J614FcA_zypFB3sGtxDMyfAVLntDuvKx2WGSTgYU9oTG-oEmg/pub"
                    // link: "https://docs.google.com/document/d/1-9NkLE05NeZ8XcF-4ImtacKJilQZMN37/export?format=pdf"
                  },
                  {
                    title: "Full Stack",
                    link: "https://docs.google.com/document/d/e/2PACX-1vS-Acr_Iv5FzfrL3J614FcA_zypFB3sGtxDMyfAVLntDuvKx2WGSTgYU9oTG-oEmg/pub"
                    // link: "https://docs.google.com/document/d/1-9NkLE05NeZ8XcF-4ImtacKJilQZMN37/export?format=pdf"
                  },
                  {
                    title: "React",
                    link: "https://docs.google.com/document/d/e/2PACX-1vREno85MZtKQNnrNaior6Vqtr1gsPsHI8N298drI7EtNGfiw_l-FhcOrDFGS8V5Sg/pub"
                    // link: "https://docs.google.com/document/d/1oGAEv4a4PMyvSYKVUMAaFL4BGygYz0cE/export?format=pdf"
                  },
                  {
                    title: "Angular",
                    link: "https://docs.google.com/document/d/e/2PACX-1vQ62mozAL5mA_k39n4w2OrmcVUctvFkvUafF8iUKXKjs-X3q0ghRL7qW_hJwpr1dQ/pub"
                    // link: "https://docs.google.com/document/d/11mS8y440NqGKlz8valWWkKXnqdGJu4hZ/export?format=pdf"
                  },
                  {
                    title: "React Native",
                    link: "https://docs.google.com/document/d/e/2PACX-1vTmNUoNHJTe6NynZbHsFp4hjExGYga1Ah6Fl7OeoF_edK-CoOHs5h42IJR8x55WQw/pub"
                    // link: "https://docs.google.com/document/d/1-R1piHK1Pqm-Ex5rVCu924jSHbHWUUiu/export?format=pdf"
                  },
                  {
                    title: "Graduate Engineer",
                    link: "https://docs.google.com/document/d/e/2PACX-1vRGYMN8HMayqX3Zr8JpGogErrkvlE9t6TH-sf4_BnqkZXqWaA3OhNwloSUPl2a8HQ/pub"
                    // link: "https://docs.google.com/document/d/1EU8nlmxbl9sHcYUGXZ5Ee4A-qKLxiA8a/export?format=pdf"
                  }
                ]}
              />
            </Grid> */}
            <Grid item>
              <ButtonGroup aria-label="outlined secondary button group">
                <Button
                  size="small"
                  onClick={() => handleButtonClick('Office Blog', 'https://ixorasolution.com/author/sn/')}
                >
                  Office Blog
                </Button>
                <Button
                  size="small"
                  onClick={() => handleButtonClick('Personal Blog', 'https://blog.shams-nahid.com/')}
                >
                  Personal Blog
                </Button>
                <Button
                  size="small"
                  onClick={() => handleButtonClick('Medium', 'https://shams-nahid.medium.com/')}
                >
                  Medium
                </Button>
              </ButtonGroup>
            </Grid>
          </Grid>
        </div>
        <div>
          <Grid container justify="center" spacing={1}>
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                startIcon={<GitHubIcon />}
                onClick={() => handleButtonClick('GitHub', 'https://github.com/shams-nahid')}
              >
                Github
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                startIcon={<LinkedInIcon />}
                onClick={() => handleButtonClick('LinkedIn', 'https://www.linkedin.com/in/shams-nahid/')}
              >
                LinkedIn
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                onClick={() => handleButtonClick('Stack Overflow', 'https://stackoverflow.com/users/5361646/shams-nahid')}
              >
                Stack Overflow
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                onClick={() => handleButtonClick('LeetCode', 'https://leetcode.com/u/shams-nahid/')}
              >
                LeetCode
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                onClick={() => handleButtonClick('npm', 'https://www.npmjs.com/~bmshamsnahid')}
              >
                npm
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                onClick={() => handleButtonClick('Free Code Camp', 'https://www.freecodecamp.org/bmshamsnahid')}
              >
                Free Code Camp
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="outlined"
                onClick={() => handleButtonClick('Strava', 'https://www.strava.com/athletes/126358041')}
              >
                Strava
              </Button>
            </Grid>
          </Grid>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Grid item><BlogList /></Grid>
        </div>
        <div style={{
          width: '100%',
          textAlign: 'center',
          paddingTop: '12px'
        }}>
          <Grid item >My Latest Run Stats...</Grid>
          <iframe height='454' frameBorder='0' allowTransparency='true' scrolling='no' src='https://www.strava.com/athletes/126358041/latest-rides/8f8366eb73307dfb6ca15a6cd57df614f1eb4a21'></iframe>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;